import { useLocation } from "react-router-dom";

function useViewController() {
  const { pathname } = useLocation();
  const isShowFooter = pathname === "/landing" || pathname === "/features" || pathname === "/" || pathname === "/terms" || pathname === "/privacy";

  return {
    isShowFooter,
  };
}

export default useViewController;
